import React from "react";
var __jsx = React.createElement;
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import stl from "./ChangeAccountVerificationModal.module.css";
import { useTranslation } from "@i18n";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { CDN_LINK } from "@globalConfig";
import { useEffect } from "react";
var ChangeAccountVerificationModal = function ChangeAccountVerificationModal(_ref) {
  var show = _ref.show,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    newPhoneNumber = _ref.newPhoneNumber,
    loading = _ref.loading;
  var _useTranslation = useTranslation(["web_checkout_cash"]),
    t = _useTranslation.t;
  var _useSession = useSession(),
    user = _useSession.user,
    isLoggedIn = _useSession.isLoggedIn;
  useEffect(function () {
    if (show && !isLoggedIn) {
      onSubmit();
    }
  }, [show]);
  return /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: show,
    onClose: onClose,
    className: stl.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/blue-back-door.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("h3", null, t("logged_account_number", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, user === null || user === void 0 ? void 0 : user.phone_number), /*#__PURE__*/React.createElement("h3", null, t("create_account_number", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, newPhoneNumber), /*#__PURE__*/React.createElement("div", {
    className: stl.btnsWrapper
  }, /*#__PURE__*/React.createElement(SubmitButton, {
    className: ["blueBtn"],
    onClick: onSubmit,
    loading: loading
  }, t("continue", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement(SubmitButton, {
    className: ["whtBtn"],
    onClick: onClose
  }, t("return_edit_number", {
    ns: "web_checkout_cash"
  })))));
};
export default ChangeAccountVerificationModal;